import { Component, Inject, Input, OnInit } from '@angular/core';
import { ICalendarEvent, IEmployeeRating } from '@common/types';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'com-employee-ratings',
  templateUrl: './employee-ratings.component.html'
})
export class EmployeeRatingsComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IEmployeeRating[]) {}
}
